import React, { useEffect, useState } from "react";
import { Routes, Route, useLocation } from "react-router-dom";
import { extendTheme, styled } from "@mui/material/styles";
import DashboardIcon from "@mui/icons-material/Dashboard";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
import { AppProvider } from "@toolpad/core/AppProvider";
import { DashboardLayout } from "@toolpad/core/DashboardLayout";
import { PageContainer } from "@toolpad/core/PageContainer";
import Grid from "@mui/material/Grid2";
import Orders from "./Orders/Orders";
import Button from "@mui/material/Button";
import { AccountCircleOutlined, LogoutOutlined } from "@mui/icons-material";
import { Axios } from "../../../Api/axios";
import Cookie from "cookie-universal";
import { baseURL, LOGOUT, USER } from "../../../Api/Api";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import BarChartIcon from "@mui/icons-material/BarChart";
import DescriptionIcon from "@mui/icons-material/Description";
import ShareIcon from "@mui/icons-material/Share";
import {
  Clients,
  ClientsCreate,
  ProjectDetail,
  Projects,
  ProjectsCreate,
  Services,
  ServicesCreate,
  SocialLinks,
  SocialLinksCreate,
  Tags,
  TagsCreate,
  Testimonial,
} from "..";
import PersonIcon from "@mui/icons-material/Person";
import MiscellaneousServicesIcon from "@mui/icons-material/MiscellaneousServices";
import StyleIcon from "@mui/icons-material/Style";
import PaletteIcon from "@mui/icons-material/Palette";
import { Breadcrumbs } from "@mui/material";
import CommentIcon from "@mui/icons-material/Comment";

const NAVIGATION = [
  {
    kind: "header",
    title: "Main items",
  },
  {
    segment: "panel",
    title: "Dashboard",
    icon: <DashboardIcon />,
  },
  {
    kind: "divider",
  },

  {
    segment: "panel/social-links",
    title: "Social Links",
    icon: <ShareIcon />,
    children: [
      {
        title: "Social Links",
        icon: <ShareIcon />,
      },
      {
        segment: "create",
        title: "create",
        icon: <DescriptionIcon />,
      },
    ],
  },
  {
    kind: "divider",
  },
  {
    segment: "panel/clients",
    title: "Clients",
    icon: <PersonIcon />,
    children: [
      {
        title: "Clients",
        icon: <PersonIcon />,
      },
      {
        segment: "create",
        title: "create",
        icon: <DescriptionIcon />,
      },
    ],
  },
  {
    kind: "divider",
  },
  {
    segment: "panel/services",
    title: "Services",
    icon: <MiscellaneousServicesIcon />,
    children: [
      {
        title: "Services",
        icon: <MiscellaneousServicesIcon />,
      },
      {
        segment: "create",
        title: "create",
        icon: <DescriptionIcon />,
      },
    ],
  },
  {
    kind: "divider",
  },
  {
    segment: "panel/tags",
    title: "Tags",
    icon: <StyleIcon />,
    children: [
      {
        title: "Tags",
        icon: <StyleIcon />,
      },
      {
        segment: "create",
        title: "create",
        icon: <DescriptionIcon />,
      },
    ],
  },
  {
    kind: "divider",
  },
  {
    segment: "panel/projects",
    title: "Projects",
    icon: <PaletteIcon />,
    children: [
      {
        title: "projects",
        icon: <PaletteIcon />,
      },
      {
        segment: "create",
        title: "create",
        icon: <DescriptionIcon />,
      },
    ],
  },
  {
    kind: "divider",
  },
  {
    segment: "panel/testimonial",
    title: "Testimonial",
    icon: <CommentIcon />,
  },
];

const demoTheme = extendTheme({
  colorSchemes: { light: true, dark: true },
  colorSchemeSelector: "class",
  breakpoints: {
    values: {
      xs: 0,
      sm: 600,
      md: 600,
      lg: 1200,
      xl: 1536,
    },
  },
});

// function useDemoRouter(initialPath) {
//   const [pathname, setPathname] = React.useState(initialPath);

//   const router = React.useMemo(() => {
//     return {
//       pathname,
//       searchParams: new URLSearchParams(),
//       navigate: (path) => setPathname(String(path)),
//     };
//   }, [pathname]);

//   return router;
// }

const Skeleton = styled("div")(({ theme, height }) => ({
  backgroundColor: theme.palette.action.hover,
  borderRadius: theme.shape.borderRadius,
  height,
  content: '" "',
}));

export default function DashboardLayoutBasic(props) {
  const { window } = props;

  const [session, setSession] = useState({
    user: {
      name: "no name",
      email: "no email",
      image: "",
    },
  });
  const navigate = useNavigate();
  const [user, setUser] = useState("");
  const cookie = Cookie();
  const token = cookie.get("dashboardLogin"); // Token from cookie
  // Fetch user data and update session
  useEffect(() => {
    const fetchUserData = async () => {
      try {
        if (token) {
          const response = await axios.get(`${baseURL}/${USER}`, {
            headers: { Authorization: `Bearer ${token}` },
          });
          setUser(response.data);
          setSession({
            user: {
              name: response.data.user.name,
              email: response.data.user.email,
              image: response.data.user.image || <AccountCircleOutlined />,
            },
          });
        }
      } catch (error) {
        console.error("Error fetching user data:", error);
      }
    };

    fetchUserData();
  }, [token]);

  const authentication = React.useMemo(
    () => ({
      signIn: async () => {
        // Your sign-in logic here
      },
      signOut: async () => {
        try {
          const cookie = Cookie();
          cookie.remove("dashboardLogin");
          cookie.remove("userRole");
          await Axios.post(`/${LOGOUT}`);
          setSession(null);
          navigate("/login");
        } catch (err) {
          console.error("Logout error:", err.response?.data || err.message);
          setSession(null);
          navigate("/login");
        }
      },
    }),
    [LOGOUT, navigate]
  );
  const location = useLocation();
  const pathParts = location.pathname.split("/").filter(Boolean); // Remove empty parts

  // const router = useDemoRouter("/dashboard");

  const handleLogout = () => {
    authentication.signOut(); // Use the existing authentication method
    // router.navigate("/login");
    console.log("logged out");
  };

  return (
    <AppProvider
      session={session}
      authentication={authentication}
      navigation={NAVIGATION}
      branding={{
        logo: <img src="../../../assets/dashboard/images/logo-34.png" />,
        title: "",
        homeUrl: "/panel",
      }}
      // router={router}
      theme={demoTheme}
    >
      <DashboardLayout>
        <PageContainer maxWidth="xl">
          <Breadcrumbs /> {/* Display current location dynamically */}
          <Grid container spacing={2}>
            <Routes>
              <Route
                path="panel/social-links/create"
                element={<SocialLinksCreate />}
              />
              <Route path="panel/social-links" element={<SocialLinks />} />
              <Route path="panel/clients/create" element={<ClientsCreate />} />
              <Route path="panel/clients" element={<Clients />} />
              <Route
                path="panel/services/create"
                element={<ServicesCreate />}
              />
              <Route path="panel/services" element={<Services />} />
              <Route path="panel/tags/create" element={<TagsCreate />} />
              <Route path="panel/tags" element={<Tags />} />
              <Route
                path="panel/projects/create"
                element={<ProjectsCreate />}
              />
              <Route path="panel/projects" element={<Projects />} />
              <Route path="panel/projects/:id" element={<ProjectDetail />} />
              <Route path="panel/testimonial" element={<Testimonial />} />
            </Routes>
          </Grid>
        </PageContainer>
      </DashboardLayout>
    </AppProvider>
  );
}
